import React, { createContext, useContext } from 'react';
import { useModalWatch } from '../../../../shared/packages/modalManager';

export const contextNames = {
  modalName: 'name',
  entity: 'entity',
  formControl: 'control',
  initialValue: 'initialValue',
  setIsFetchOptionsError: 'setIsFetchOptionsError',
};

const valueGetters = {
  [contextNames.modalName]: (props) => props?.name,
  [contextNames.entity]: (props) => props?.entity,
  [contextNames.formControl]: (props) => props?.control,
  [contextNames.initialValue]: (props) => props?.initialValue,
  [contextNames.setIsFetchOptionsError]: (props) =>
    props?.setIsFetchOptionsError,
};

export const contexts = Object.values(contextNames).reduce((acc, name) => {
  acc[name] = createContext();
  return acc;
}, {});

export const PropsProvider = ({ children, ...props }) => {
  return Object.entries(contexts).reduce(
    (acc, [key, Context]) => (
      <Context.Provider value={valueGetters[key](props)}>
        {acc}
      </Context.Provider>
    ),
    children
  );
};

export const useAddressId = () => {
  const name = useContext(contexts[contextNames.modalName]);
  return useModalWatch({ name, selector: selectRoomId });
};

// селекторы
function selectRoomId(state) {
  return state?.props?.room?.id;
}
